@if (configuration()?.src) {
    <div class="inline">
        @if (lazy() && lazySizesEnabled()) {
            @defer (hydrate never) {
                <app-lazy-asset-lazy
                    [additionalClasses]="additionalClasses()"
                    [altText]="altText()"
                    [defaultSrc]="defaultSrc()"
                    [svgPlaceholder]="svgPlaceholder()"
                    [sourceSet]="srcSet()"></app-lazy-asset-lazy>
            }
        } @else {
            <img
                class="w-full"
                [ngClass]="additionalClasses()"
                [src]="defaultSrc() || ''"
                [alt]="altText()" />
        }
    </div>
} @else {
    No image provided.
}
